import { Category } from './types';

export const mockCategories: Category[] = [
  {
    id: 'cat-appetizers',
    name: 'Appetizers',
    description: 'Starters and small plates',
    itemCount: 6,
    isVisible: true,
    sortPosition: 0,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
  {
    id: 'cat-main-course',
    name: 'Main Course',
    description: 'Hearty entrees and signature dishes.',
    itemCount: 8,
    isVisible: true,
    sortPosition: 1,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
  {
    id: 'cat-burgers',
    name: 'Burgers',
    description: 'Handcrafted burgers with premium ingredients.',
    itemCount: 4,
    parentCategoryId: 'cat-main-course',
    isVisible: true,
    sortPosition: 0,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
  {
    id: 'cat-pasta',
    name: 'Pasta',
    description: 'Fresh and dried pasta dishes.',
    itemCount: 4,
    parentCategoryId: 'cat-main-course',
    isVisible: true,
    sortPosition: 1,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: false, catering: false },
  },
  {
    id: 'cat-beverages',
    name: 'Beverages',
    description: 'Hot and cold drinks, juices, and smoothies.',
    itemCount: 7,
    isVisible: true,
    sortPosition: 2,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
  {
    id: 'cat-cocktails',
    name: 'Cocktails',
    description: 'Signature cocktails and classic mixes.',
    itemCount: 4,
    parentCategoryId: 'cat-beverages',
    isVisible: true,
    sortPosition: 0,
    orderTypeVisibility: { dine_in: true, takeout: false, delivery: false, online_ordering: false, catering: false },
  },
  {
    id: 'cat-soft-drinks',
    name: 'Soft Drinks',
    description: 'Non-alcoholic beverages and refreshments.',
    itemCount: 3,
    parentCategoryId: 'cat-beverages',
    isVisible: true,
    sortPosition: 1,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
  {
    id: 'cat-desserts',
    name: 'Desserts',
    description: 'Sweet treats and after-dinner indulgences.',
    itemCount: 5,
    isVisible: true,
    sortPosition: 3,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
  {
    id: 'cat-sides',
    name: 'Sides',
    description: 'Complementary dishes to pair with your main course.',
    itemCount: 4,
    isVisible: true,
    sortPosition: 4,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
  {
    id: 'cat-salads',
    name: 'Salads',
    description: 'Fresh salads and healthy bowls.',
    itemCount: 3,
    isVisible: true,
    sortPosition: 5,
    orderTypeVisibility: { dine_in: true, takeout: true, delivery: true, online_ordering: true, catering: true },
  },
];
